const epsilon = 1e-9;

/**
 * Runs the game's logic in fixed steps, however uneven the frames: the rules see the same small step every time, and
 * a frame that stalled (a hidden tab, a slow moment) does not make them race to catch up.
 */
export class FixedStep {
  private carried = 0;

  constructor(readonly stepSeconds: number, private readonly maxSteps = 8) {}

  /** Calls step for each whole step in this much time; returns how far into the next step it is (0..1), for smooth drawing. */
  advance(seconds: number, step: (seconds: number) => void): number {
    this.carried = Math.min(this.carried + seconds, this.stepSeconds * this.maxSteps);
    // A hair under a whole step still counts: sums of fractions of a second never come out exact.
    while (this.carried >= this.stepSeconds - epsilon) {
      this.carried = Math.max(0, this.carried - this.stepSeconds);
      step(this.stepSeconds);
    }
    return this.carried / this.stepSeconds;
  }
}
